import { z } from 'zod'

/** Generic ID schema for parsing strings into branded IDs. Prefer a specific ID type where one exists. */
export const Id = z.string().brand('ID')
export const Slug = z.string().brand('Slug')

export type ID = z.infer<typeof Id>
export type Slug = z.infer<typeof Slug>
